import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiUrls } from './ApiUrls';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FileResponseModel } from '../model/FileResponseModel';
import { QueryExecutorModel } from '../model/QueryExecutorModel';
import { QueryExecutorDetailModel } from '../model/QueryExecutorDetailModel';
import { Page } from '../model/Page';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) { }

  initReportForm() {
    return this.httpClient.get<{
      lotteryList: {[key: number]: string}, 
      reports: {[key: string]: string}, 
      status: string, 
      errorMessage: string
    }>(ApiUrls.reportInitFormUrl);
  }
  
  generateReport(selectedReport: number, dependencies: {lotteryKey: number}) {
    return this.httpClient.post<FileResponseModel>(ApiUrls.generateReportUrl.replace('{selectedReport}', selectedReport.toString()), dependencies);
  }
  
  fetchQueryExecutorReport(selectedReport: number) {
    return this.httpClient.get<{lst: {[key: string]: string}[], title: string, columnNames: string[],
    columnWidths: string, status: string, errorMessage: string, generatedBy: string, generatedOn: string}>(ApiUrls.queryExecutorReportUrl.replace('{selectedReport}', selectedReport.toString()));
  }

  fetchQueryExecutorList(page: number, size: number, filterText: string) {
    return this.httpClient.get<Page<QueryExecutorModel>>(ApiUrls.queryExecutorList + 
      `?page=${page}&size=${size}&filterText=${filterText}`);
  }

  initQueryExecutorForm() {
    return this.httpClient.get<{
      boards: {[key: number]: string}, 
    }>(`${ApiUrls.initQueryExecutorFormUrl}`);
  }

  getQueryExecutorBykey(key: number) {
    return this.httpClient.get<QueryExecutorDetailModel>(`${ApiUrls.queryExecutorDetail.replace('{queryExecutorKey}', key.toString())}`);
  }

  saveQueryExecutor(data: {
    boardKey: number,
    reportName: string,
    reportDescription: string,
    query: string,
    columnNames: string,
    columnWidths: string
  }) {
    return this.httpClient.post<{status: string, errorMessage: string}>(`${ApiUrls.saveQueryExecutor}`, data); 
  }

  updateQueryExecutor(key: number, data: {
    boardKey: number,
    reportName: string,
    reportDescription: string,
    query: string,
    columnNames: string,
    columnWidths: string
  }) {
    return this.httpClient.put<{status: string, errorMessage: string}>(ApiUrls.updateQueryExecutor.replace('{queryExecutorKey}', key.toString()), data); 
  }

  toggleActivationQueryExecutor(key: number, activeFlag: string) {
    return this.httpClient.patch<{status: string, errorMessage: string}>(ApiUrls.toggleActivationQueryExecutorUrl.replace('{queryExecutorKey}', key.toString()), {
      activeFlag
    }); 
  }

  async successToast(msg) {
    await this._snackBar.open(
      msg,
      "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: dur ? dur : 3 * 1000,
      }
    );
  }
}
